import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  ShipmentIssue,
  ShipmentIssueListResponse,
  ShipmentIssueFilter,
  ShipmentIssueDetailResponse,
} from '../../../data/interfaces';
import { ShipmentIssueCategory } from '../../../data/constants/shipment-issue-categories';

@Injectable({
  providedIn: 'root',
})
export class ShipmentIssueService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCategories(): Observable<ShipmentIssueCategory[]> {
    return this.http
      .get<{ success: boolean; data: ShipmentIssueCategory[] }>(`${this.apiUrl}/shipment-issue/categories`)
      .pipe(map((res) => res.data));
  }

  getShipmentIssueList(filter: ShipmentIssueFilter): Observable<ShipmentIssueListResponse> {
    return this.http.get<ShipmentIssueListResponse>(`${this.apiUrl}/shipment-issue/list`, {
      params: filter as any,
    });
  }

  getShipmentIssueDetail(id: string): Observable<ShipmentIssue> {
    return this.http
      .get<ShipmentIssueDetailResponse>(`${this.apiUrl}/shipment-issue/details/${id}`)
      .pipe(map((response) => response.data));
  }

  createShipmentIssue(payload: Partial<ShipmentIssue>): Observable<ShipmentIssue> {
    return this.http
      .post<any>(`${this.apiUrl}/shipment-issue/create`, payload)
      .pipe(map((response) => response.data));
  }

  updateShipmentIssue(id: string, updates: Partial<ShipmentIssue>): Observable<ShipmentIssue> {
    return this.http
      .put<ShipmentIssueDetailResponse>(`${this.apiUrl}/shipment-issue/update/${id}`, updates)
      .pipe(map((response) => response.data));
  }

  deleteShipmentIssue(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/shipment-issue/delete/${id}`);
  }

  searchShipmentByNumber(shipmentNo: string): Observable<{ shipment: any }> {
    return this.http
      .get<{ success: boolean; data: { shipment: any } }>(`${this.apiUrl}/shipment-issue/shipment-search`, {
        params: { shipmentNo: shipmentNo?.trim() || '' },
      })
      .pipe(map((res) => res.data));
  }
}
